import { render, staticRenderFns } from "./FormAddressType.vue?vue&type=template&id=53ffe718"
import script from "./FormAddressType.vue?vue&type=script&lang=js"
export * from "./FormAddressType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports